<template>
    <span v-if="dada=='tipus'" 
    :title="
    colla.tipus=='convencional'?'Colla Convencional':
    colla.tipus=='universitaria'?'Colla Universitaria':
    colla.tipus=='internacional'?'Colla Internacional':
    'Colla '+colla.tipus
    " 
    role="tooltip">
    <font-awesome-icon
    class="opacity-50 hover:opacity-70"
    

    :icon="colla.tipus=='convencional'?['fas', 'house']:
    colla.tipus=='universitaria'?['fas', 'graduation-cap']:
    colla.tipus=='internacional'?['fas', 'earth-americas']:
    colla.tipus=='aficionats'?['fas', 'arrows-to-dot']:
    colla.tipus=='projecte'?['fas', 'lightbulb']:
    colla.tipus=='efimera'?['fas','hourglass-half']:
    colla.tipus=='seccio'?['fas','chart-pie']:
    colla.tipus=='ficticia'?['fas','film']:
    ['fas', 'circle-question']
    "/>
    <tippy v-if="tippy==true"  to="parent" placement="top" trigger="mouseenter" theme="light" content-tag="div" content-class="w-fit p-2 rounded-sm text-center" >
        Colla {{ Format(colla.tipus).singular }}</tippy>
    </span>
<span v-else-if="dada=='estat'"
:title="
    colla.estat=='activa'?'Colla Activa':
    colla.estat=='formacio'?'Colla en Formació':
    colla.estat=='desapareguda'?'Colla Desapareguda':
    'Colla '+colla.estat
    " 
    role="tooltip"
>
    <font-awesome-icon
    class="opacity-50 hover:opacity-70"

    :icon="colla.estat=='activa'?['fas', 'fire']:
    colla.estat=='formacio'?['fas', 'seedling']:
    colla.estat=='desapareguda'?['fas', 'cross']:
    ['fas', 'circle-question']
    "/>
    <tippy v-if="tippy==true" to="parent" placement="top" trigger="mouseenter" theme="light" content-tag="div" content-class="w-fit p-2 rounded-sm text-center" >
        Colla {{ Format(colla.estat).singular }}</tippy>
    </span>
</template>

<script setup>
import {ref, defineProps} from 'vue';
import Format from '@/functions/formatTipEst.js'

const props= defineProps({
    colla:{
        type: Object,
        required: true
    },
    dada:{
        type: String,
        required: true,
        default:'tipus'
    },
    tippy:{
        type:Boolean,
        required:false,
        default:false
    }
})

let colla=ref(props.colla)

</script>